<script setup>
import { ref, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import api from '@/entrypoints/public/plugins/axios'

import PropertyCover from '../pages/property_detail/PropertyCover.vue'
import ResidentialComplexInfo from '../pages/residential_complex/ResidentialComplexInfo.vue'
import ResidentialComplexFeatures from '../pages/residential_complex/ResidentialComplexFeatures.vue'
import PropertyVideo from '../pages/property_detail/PropertyVideo.vue'
import PropertyMap from '../pages/PropertyMap.vue'
import PropertyGallery from '../pages/property_detail/PropertyGallery.vue'
import BackButton from '../pages/property_detail/BackButton.vue'
import ResidentialComplexProperties from '../pages/residential_complex/ResidentialComplexProperties.vue'
import PageHero from '../components/PageHero.vue'

const complex = ref(null)
const { locale } = useI18n()

const loadComplex = async () => {
  try {
    const pathParts = window.location.pathname.split('/')
    const developerId = pathParts[3]
    const complexId = pathParts[5]

    const res = await api.get(`/developers/${developerId}/residential_complexes/${complexId}`, {
      headers: {
        'X-Locale': locale.value
      }
    })

    complex.value = res.data
    document.title = res.data.name || 'Жилой комплекс'
  } catch (e) {
    console.error('Ошибка загрузки ЖК:', e)
  }
}

onMounted(() => {
  loadComplex()
})

watch(locale, () => {
  loadComplex()
})
</script>

<template>
  <div v-if="complex">
    <ResidentialComplexHero v-if="complex" :complex="complex" />

    <section class="module ptb-100">
      <div class="container">
        <div class="row">
          <!-- Левая колонка -->
          <div class="col-lg-4 col-md-4">
            <div class="sidebar-left pr-4">
              <PropertyCover
                v-if="complex.cover_image_url"
                :coverImageUrl="complex.cover_image_url"
                :weight="'200px'"
              />

              <ResidentialComplexFeatures v-if="complex" :complex="complex" />

              <PropertyVideo
                v-if="complex.video_urls?.length"
                :video-url="complex.video_urls[0]"
              />
            </div>
          </div>

          <!-- Правая колонка -->
          <div class="col-lg-8 col-md-8">
            <ResidentialComplexInfo :complex="complex" />

            <PropertyMap
              v-if="complex.latitude && complex.longitude"
              :latitude="complex.latitude"
              :longitude="complex.longitude"
            />

            <PropertyGallery
              v-if="complex.gallery_images?.length"
              :galleryImages="complex.gallery_images"
            />

            <BackButton />
          </div>
        </div>

        <ResidentialComplexProperties
          v-if="complex.id"
          :residential-complex-id="complex.id"
        />
      </div>
    </section>
  </div>

  <div v-else class="text-center text-gray-500 mt-10">
    Загрузка данных жилого комплекса...
  </div>
</template>
